// extracted by mini-css-extract-plugin
module.exports = {"detail_gift":"detail_gift--WkFO-"};